// extracted by mini-css-extract-plugin
export default {"home_container":"home_home_container__nKOYL"};